import { actionTypesFor } from '../common/redux-crud-actions'
import { createBoundActions } from '../common/bound-actions'
import { webStorage } from '../common/web-storage'
import { DEFAULT_CONTEXT_PATH } from '../common/constants'

const AUTH_KEY = 'authKey'
const RESOURCE_KEY = 'config'

// Reloads the application if the authKey changes. See comment below for details.
webStorage.addStorageListener(evt => {
    if (evt.key === AUTH_KEY && evt.oldValue !== evt.newValue) {
        window.location.reload(true)
    }
})

export const configActionTypes = actionTypesFor(RESOURCE_KEY)

/**
 * Redux action thunk for 'web-config' resource
 *
 * @param {string} contextPath - The URL path prefix to be used (Atlantis uses '/api')
 * @param {string} resourcePath - The resource path of the config REST resource (normally '/config')
 * @return {Promise}
 */
export function createConfigActions(contextPath = DEFAULT_CONTEXT_PATH, resourcePath = '/' + RESOURCE_KEY) {
    return createBoundActions(RESOURCE_KEY, contextPath, resourcePath, null)
}

/**
 * Convenience Redux action thunk for retrieving the 'web-config' resource and save the contained
 * authKey in to the local storage.
 *
 * @param {string} pathPrefix - The URL path prefix to be used (Atlantis uses '/api')
 * @param {string} resourcePath - The resource path of the config REST resource (normally '/config')
 * @return {Promise}
 */
export function createFetchWebConfigThunk(pathPrefix = DEFAULT_CONTEXT_PATH, resourcePath = '/' + RESOURCE_KEY) {
    const configActions = createConfigActions(pathPrefix, resourcePath)

    return function fetchWebConfig(dispatch) {
        return dispatch(configActions.fetch()).then(webConfig => {
            // Technically only one session at a time is supported. Thus it is necessary to make sure all
            // opened tabs with the same active application see the same data.
            // The webConfig contains a unique auth key, which is used to identify a session.
            // This key is stored in the browsers local storage. If this key changes ans appropriate StorageEvent is
            // dispatched to the other active browser tabs. There, the storage listener above takes care of reloading
            // the application appropriately.
            webStorage.save(AUTH_KEY, webConfig[AUTH_KEY])
        })
    }
}
